import { getAll as _getAll } from "../api";
import { dateToString } from "utils/dateUtils";

let BASE_URL = null;

export function initDB(dbName) {
    BASE_URL = `/modules/${dbName}/file-cases`;
}

function normalizeRequestData(data) {
    const { stampCreationDatetime: stampCreationDatetimeInMillis, stampModificationDatetime: stampModificationDatetimeInMillis } = data;

    const stampCreationDatetime = new Date(stampCreationDatetimeInMillis);
    const stampModificationDatetime = new Date(stampModificationDatetimeInMillis);

    return {
        ...data,
        stampCreationDatetime,
        stampModificationDatetime,
        stampCreationDatetimeString: dateToString(stampCreationDatetime),
        stampModificationDatetimeString: dateToString(stampModificationDatetime),
    };
}

function normalizeData(data) {
    return data.map(normalizeRequestData);
}

export function getAll({ fileCaseId, onSuccess, onInfo, onError }) {
    _getAll({
        url: `${BASE_URL}/${fileCaseId}/coc/requests`,
        onSuccess,
        onInfo,
        onError,
        normalizer: normalizeData,
    });
}
